export function isDevServer() {
    var myURL = new URL(window.location.href);
    return myURL.hostname === 'dev.routy.com';
}
